import * as queries from './queries';
import app from 'dashboard/app';

function GraphQLError(message, code) {
  this.message = message;
  this.code = code;
  this.name = 'GraphQLError';
}

export function setSubjectId({ commit }, subjectId) {
  commit('setSubjectId', subjectId);
}

export async function getData({ dispatch, commit, getters }) {
  const { subjectId } = getters;
  
  commit('resetData');

  try {
    const { data, errors } = await app.apolloClient.query({
      query: queries.getBaseEDCSubject,
      variables: { subjectId },
    });

    if (data && !errors && data.baseEDCSubject) {
      const { gender, birthYear, startDate } = data.baseEDCSubject;
      if (gender) commit('setGender', gender);
      if (birthYear) commit('setBirthYear', birthYear);
      if (startDate) commit('setStartDate', startDate);
    } else if (errors.length) {
      errors.forEach((error) => {
        const { extensions } = error;
        const details = extensions.validation.subjectId[0];
        throw new GraphQLError(details.message, details.parameters['{{ code }}']);
      });
    }
  } catch (error) {
    const messageList = [
      'PATIENT_ALREADY_EXISTS',
      'INVALID_STUDY_ID',
      'PATIENT_IS_NOT_RANDOMIZED',
    ];
    // Throw to translate
    if (messageList.includes(error.code)) {
      throw error
    } else {
      // Just show the error
      dispatch('error/submit', new Error (error.message), { root: true });
    }
  }
}

export async function create({ dispatch, getters }) {
  const { subjectId } = getters;

  try {
    const { data, errors } = await app.apolloClient.query({
      query: queries.createPatient,
      variables: { subjectId },
    });

    if (data && !errors && data.createUpdatePatient) {
      const { user } = data.createUpdatePatient || {};
      const { patientId } = user;

      return patientId;
    } else if (errors.length) {
      errors.forEach((error) => {
        dispatch('error/submit', error, { root: true });
      });

      return null;
    }
  } catch (error) {
    dispatch('error/submit', error, { root: true });

    return null;
  }
}

export async function reset({ commit }) {
  commit('reset');
}